export default __webpack_public_path__ + "static/media/edital42024retificado.0793b01a.pdf";